import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DivIcon from 'react-leaflet-div-icon';
import { CircleMarker } from 'react-leaflet';

import { onParkingSpotClick } from './../../actions/parkingSpots';
import { currentStateForSpot, checkUserLoggedIn, checkIsFilteredSpot } from './../../utils';
import { SHOW_PARKING_SPOTS_MARKER_TEXT_ZOOM_LEVEL } from '../../constants';

class ParkingSpotMarker extends Component {

  constructor(props) {
    super(props);
    this.handleMarkerClick = this.handleMarkerClick.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { spotid } = nextProps.feature.properties;
    if(nextProps.selectedSpot !== this.props.selectedSpot) {
      //Updating component for selectedSpot marker & last selected marker only
      return (nextProps.selectedSpot === spotid || this.props.selectedSpot === spotid);
    }
    if((nextProps.reservedSpots === this.props.reservedSpots) && (nextProps.allFilteredSpots === this.props.allFilteredSpots) && (nextProps.showMarkerText === this.props.showMarkerText)) {
      //if reservedSpots & filteredSpots are same & only status change then updating marker else not updating marker
      if(nextProps.parkingSpotsList[spotid] && this.props.parkingSpotsList[spotid]) {
        return (nextProps.parkingSpotsList[spotid].status !== this.props.parkingSpotsList[spotid].status);
      }else {
        //console.log(`Spot id not present spot json ${spotid},`);
      }

    }
    return true;
  }

  handleMarkerClick(e) {
    e.originalEvent.preventDefault();
    const { feature } = this.props;
    this.props.onParkingSpotClick(feature.properties);
  }

  parkingSpotStyle(feature) {
    const { spotid:spotId } = feature.properties;
    const isFilteredSpot = checkIsFilteredSpot(spotId);
    const currentState = currentStateForSpot(spotId);

    const { selectedSpot, reservedSpots, isUserLoggedIn, allFilteredSpots } = this.props;

    const isReservedByMe = isUserLoggedIn ? reservedSpots.includes(spotId) : false;

    const { status } = currentState;
    const isOpenSpot = status === 'OPEN';
    let className = 'i-icon-marker-pin-unavailable';
    let classNamePulse = '';

    if (isReservedByMe){
      className = 'i-icon-marker-pin-myspot';
      classNamePulse = 'myspot-pulse';
    }else if (spotId === selectedSpot) {
      if(isFilteredSpot) {
        if(isOpenSpot){
          className = 'i-icon-marker-pin-filtered-focus';
        } else {
          className = 'i-icon-marker-pin-unavailable-filtered-focus';
        }
      } else {
        if(isOpenSpot) {
          className = 'i-icon-marker-pin-focus';
        }else {
          className = 'i-icon-marker-pin-unavailable-focus';
        }
      }
    }else if (isFilteredSpot) {
      className = isOpenSpot ? 'i-icon-marker-pin-filtered': 'i-icon-marker-pin-unvailable-filtered';
    }else if (isOpenSpot) {
      className = 'i-icon-marker-pin';
    }
    return {
      className,
      classNamePulse
    };
  }

  // @todo -- handle this on parent component and send as a prop
  // getRadius(zoomLevel) {
  //   let radius = 5;
  //   switch (zoomLevel) {
  //     case 20:
  //       radius = 10;
  //       break;
  //     case 19:
  //       radius = 5;
  //       break;
  //     case 18:
  //     default:
  //       radius = 2;
  //   }
  //   console.log(zoomLevel, radius)
  //   return radius;
  // }

  render() {
    const { feature, zoomLevel, showMarkerText, selectedSpot } = this.props;
    const { className:iconClassName, classNamePulse } = this.parkingSpotStyle(feature);
    const { spotid } = feature.properties;
    const zIndexOffset = (spotid === selectedSpot) ? 2000 : 1000;

    // return (
    //   <CircleMarker
    //     center={feature.centerCoordinates}
    //     zIndexOffset={zIndexOffset}
    //     radius={5}
    //     color="#000000"
    //     weight={2}
    //     fill={true}
    //     onClick={this.handleMarkerClick} >
    //   </CircleMarker>
    // );

    return (
      <DivIcon
        onClick={this.handleMarkerClick}
        zIndexOffset={zIndexOffset}
        position={feature.centerCoordinates} className={`spot-marker-container`} >
        <div className={`spot-marker-wrap ${classNamePulse}`}>
          <div className={`${iconClassName} marker-icon-div`} />
          {(showMarkerText && !!spotid) && <div className="spot-marker-text">{spotid}</div>}
        </div>
      </DivIcon>
    );
  }

}

const mapStateToProps = (state) => {
  const { list:parkingSpotsList, selectedSpot, showParkingSpotMarkerLabel } = state.parkingSpots;
  const { reservedSpots } = state.userAccommodationInfo;
  const { allFilteredSpots, appliedFilters } = state.search;
  const { zoomLevel } = state.map;
  const showMarkerText = showParkingSpotMarkerLabel && (zoomLevel >= SHOW_PARKING_SPOTS_MARKER_TEXT_ZOOM_LEVEL);

  return {
    parkingSpotsList,
    appliedFilters,
    allFilteredSpots,
    showMarkerText,
    selectedSpot,
    zoomLevel,
    showParkingSpotMarkerLabel,
    reservedSpots,
    isUserLoggedIn: checkUserLoggedIn(state.user),
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({onParkingSpotClick}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ParkingSpotMarker);



// WEBPACK FOOTER //
// ./src/containers/MapLayers/ParkingSpotMarker.js